module.exports = __webpack_public_path__ + "static/Abacus Dossier aus Sicht des Mitarbeitenden im Portal-426550c915d66798b5cea1ed2d538e38.png";